var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfessionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.07 105.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#00a6e4;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:3.05px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.45,
    cy: 13.72,
    r: 13.72
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32.45,
    cy: 58.34,
    r: 27.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.34 103.23 2.15 77.88 17.15 64.16 26.14 74 55.7 45.05 69.92 59.56 25.34 103.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalIcon);
export default __webpack_public_path__ + "static/media/professional-icon.bde7f01e85ee7e3249364f5c55a2a5ef.svg";
export { ForwardRef as ReactComponent };